import {Box, Button} from '@mui/material';
export default function TimerView({
    timeSelected, setTimeSelect, 
    setStep,  
    handleHistorySave=null,
    availableTime
}) {
    console.log('availableTime::', availableTime)

    return (
        <Box sx={{
            overflow: "hidden",
            overflowY: "auto",
            height: "375px",
            width:'100%',
            px:3
        }}>
            {
                availableTime.map(t=>{
                    return (
                        <>
                            <Box sx={{display:"flex", justifyContent:"center", gap:1, alignItems:'center'}}>
                                <Button fullWidth variant="outlined" sx={{mt:1}} onClick={()=>{setTimeSelect(t)}}>
                                    {t}
                                </Button>
                                {
                                    t === timeSelected &&
                                    <Button fullWidth variant="contained" sx={{mt:1}} onClick={()=>{
                                        setStep(2);
                                        if (handleHistorySave) {
                                            handleHistorySave();
                                        }
                                    }}>
                                        Confirm
                                    </Button>
                                }
                            </Box>
                        </>
                    )
                })
            }
        </Box>
    )
}

